import React from 'react';
import styled from 'styled-components';
import { IDirection } from '../../interfaces/direction.interface';
import { IMessage } from '../../interfaces/message.interface';
import { Pre } from '../atoms';
import { ChatLeft } from './ChatLeft';
import { ChatRight } from './ChatRight';
import ClearFixStyle from '../atoms/ClearFixStyle';
import { formatDate } from '../../utils/date';
import { ChatMessageAttachments } from './ChatMessageAttachments';

const BaseStyledDiv = styled.div`
  background: #fff;
  color: #333;
  font-size: 14px;
  line-height: 1.5;
  padding: ${(props: { isWide: boolean }) =>
    props.isWide ? '0 32px 11px' : '16px 16px 16px'};
  ${(props: { isWide: boolean }) =>
    props.isWide
      ? `word-wrap: break-word;`
      : `border-collapse: separate;
      border-radius: 16px;`}
`;

const MessageStyledDiv = styled.div`
  overflow: hidden;
  margin-bottom: ${(props: { isWide: boolean }) =>
    props.isWide ? '16px !important' : '12px !important'};
  ${(props: { isWide: boolean }) =>
    props.isWide ? `margin: 0px 0 15px !important;` : `word-break: break-all;`}
`;

const DateStyledDiv = styled.div`
  font-size: 12px;
  line-height: normal;
  color: #828282;
  ${(props: { isWide: boolean }) =>
    props.isWide
      ? `float: right;
      padding-right: 2%;
      ${ClearFixStyle}`
      : `margin-top: 0px;
      text-align: left;`}
`;

interface Props {
  isWide: boolean;
  image?: string;
  userId: string;
  message: IMessage;
  onClickAttachmentThumbnail: Function;
  childrenContainerDivRef?: React.RefObject<HTMLDivElement>;
  messageDivRef?: React.RefObject<HTMLDivElement>;
  showInquiryId: boolean;
}

export const ChatMessage = (props: Props) => {
  const {
    isWide,
    image,
    userId,
    message,
    onClickAttachmentThumbnail,
    childrenContainerDivRef,
    messageDivRef,
  } = props;
  const direction: IDirection =
    userId === message.messageSender ? 'outgoing' : 'incoming';
  const ChatRightOrLeft = direction === 'outgoing' ? ChatRight : ChatLeft;

  return (
    <ChatRightOrLeft isWide={isWide} image={image}>
      <BaseStyledDiv
        isWide={isWide}
        style={{
          background: direction === 'outgoing' ? '#DCF3FF' : '',
        }}
      >
        <MessageStyledDiv
          isWide={isWide}
          ref={childrenContainerDivRef}
          // style={{
          //   height: messageDivRef!.current
          //     ? messageDivRef!.current.offsetHeight + 'px'
          //     : '',
          //   transition: 'all 0.2s ease-in-out',
          // }}
        >
          <div ref={messageDivRef}>
            <Pre>{message.messageBody}</Pre>
          </div>
        </MessageStyledDiv>
        <ChatMessageAttachments
          isWide={false}
          attachments={message.attachments}
          messageSentTimestamp={message.messageSentTimestamp}
          onClickAttachmentThumbnail={onClickAttachmentThumbnail}
        ></ChatMessageAttachments>
        <DateStyledDiv isWide={isWide}>
          {formatDate(message.messageSentTimestamp, 'YYYY/MM/DD HH:mm')}
        </DateStyledDiv>
      </BaseStyledDiv>
    </ChatRightOrLeft>
  );
};
